
import { BasicDialogHandler } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2StarterPackageBoughtDialog } from "../../../view/dialogs/starterPackages/Poker2StarterPackageBoughtDialog";
import { Poker2StarterPackageBoughtDialogProperties } from "../../../view/dialogs/starterPackages/Poker2StarterPackageBoughtDialogProperties";
import { Poker2Command } from "../Poker2Command";

export class SPBCommand extends Poker2Command {
    protected get cmdId(): string {
        return SFConstants.S2C_BOUGHT_STARTER_PACKAGE;
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            var paramObj: any = JSON.parse(params[1]);

            // parse starter package bought
            Poker2Model.itemShop.parse_spb(paramObj);

            // create starter package bought dialog
            BasicDialogHandler.getInstance().registerDialogs("Poker2StarterPackageBoughtDialog", new Poker2StarterPackageBoughtDialogProperties(), true, BasicDialogHandler.PRIORITY_HIGH);
        }
        return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
